/**
 * MSK Finding Chart Reducers
 */
import {
    ALL_INJURYCHARTS,
    ADD_INJURYCHART,
    INJURYCHART_ACTION,
    EDIT_INJURYCHART,
    FETCH_INJURYCHART,
    DELETE_INJURYCHART,
    ALL_INJURYUPDATES,
    ADD_INJURYUPDATE,
    INJURYUPDATE_ACTION,
    EDIT_INJURYUPDATE,
    FETCH_INJURYUPDATE,
    DELETE_INJURYUPDATE,
    ALL_STUDENTINJURY,
    FULL_INJURYDETAIL,
    INJURY_UPDATEDETAIL,
    EDIT_INJURYPROFILE,
    PROFILE_INJURYUPDATE,
    PROFILE_INJURYREPORT,
    ALL_INJURYREPORTS,
    DELETE_INJURYREPORTS,
    ALL_INJURYPROFILE,
    FULL_INJURYPROFILE
 } from 'Actions/types';
 
 /**
  * initial auth user
  */
 const INIT_STATE = {
     injurychartlists:[],
     injurychartresponse:[],
     injuryupdatelists:[],
     injuryupdateresponse:[],
     studentinjurylist:[],
     injuryfulldetails:[],
     injuryallupdates:[],
     injuryallfiles:[],
     injuryprofilelist:[],
     injuryallprofile:[],
     loading: false
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
         case INJURYCHART_ACTION:
             return { ...state, loading: true };
 
         case ALL_INJURYCHARTS:
             return { ...state, loading: false, injurychartlists: action.payload };  
             
         case ADD_INJURYCHART:
             return { ...state, loading: false }; 
 
         case FETCH_INJURYCHART:
             return { ...state, loading: false, injurychartresponse:action.payload };     
         
         case EDIT_INJURYCHART:
             return { ...state, loading: false };  
         
         case DELETE_INJURYCHART:
             return { ...state, loading: false };   
             
        case INJURYUPDATE_ACTION:
            return { ...state, loading: true }; 
        
        case ALL_INJURYUPDATES:
            return { ...state, loading: false, injuryupdatelists: action.payload };  
            
        case ADD_INJURYUPDATE:
            return { ...state, loading: false }; 

        case FETCH_INJURYUPDATE:
            return { ...state, loading: false, injuryupdateresponse:action.payload };     
        
        case EDIT_INJURYUPDATE:
            return { ...state, loading: false };  
        
        case DELETE_INJURYUPDATE:
            return { ...state, loading: false };    
        
        case ALL_STUDENTINJURY:
            return { ...state, loading: false, studentinjurylist:action.payload }; 
        
        case FULL_INJURYDETAIL:
            return { ...state, loading: false, injuryfulldetails:action.payload };  
        
        case INJURY_UPDATEDETAIL:
            return { ...state, loading: false, injuryallupdates:action.payload }; 
            
        case EDIT_INJURYPROFILE:
            return { ...state, loading: false };     
        
        case PROFILE_INJURYUPDATE:
            return { ...state, loading: false };    
        
        case PROFILE_INJURYREPORT:
            return { ...state, loading: false }; 
        
        case ALL_INJURYREPORTS:
            return { ...state, loading: false, injuryallfiles:action.payload }; 

        case DELETE_INJURYREPORTS:
            return { ...state, loading: false };   
            
        case ALL_INJURYPROFILE:
            return { ...state, loading: false, injuryprofilelist:action.payload };
            
        case FULL_INJURYPROFILE:
            return { ...state, loading: false, injuryallprofile:action.payload };    

         default: return { ...state };
     }
 }